"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const currentPage = (state = '', action) => action.type === 'UPDATE_CURRENT_PAGE' ? action.currentPage : state;
const segmentSize = (state = 0, action) => {
    if (action.type === 'FETCH_DEVICE_TOTAL_SIZE_SUCCESS') {
        return action.totalCount;
    }
    return state;
};
const isAudienceSizeUpdating = (state = false, action) => {
    switch (action.type) {
        case 'FETCH_AUDIENCE_SIZE_REQUEST':
            return true;
        case 'FETCH_AUDIENCE_SIZE_FAILURE':
        case 'FETCH_AUDIENCE_SIZE_SUCCESS':
            return false;
        default:
            return state;
    }
};
const isDeviceListUploading = (state = false, action) => {
    switch (action.type) {
        case 'DEVICE_LIST_UPLOAD_REQUEST':
            return true;
        case 'DEVICE_LIST_UPLOAD_FAILURE':
        case 'DEVICE_LIST_UPLOAD_SUCCESS':
            return false;
        default:
            return state;
    }
};
const isSegmentSizeUpdating = (state = false, action) => {
    switch (action.type) {
        case 'FETCH_DEVICE_TOTAL_SIZE_REQUEST':
            return true;
        case 'FETCH_DEVICE_TOTAL_SIZE_SUCCESS':
        case 'FETCH_DEVICE_TOTAL_SIZE_FAILURE':
            return false;
        default:
            return state;
    }
};
exports.default = redux_1.combineReducers({
    currentPage,
    segmentSize,
    isAudienceSizeUpdating,
    isDeviceListUploading,
    isSegmentSizeUpdating,
});
exports.getCurrentPage = (state) => state.currentPage;
exports.getShouldShowPhonePreview = (state, editableCampaign) => {
    const currentPage = exports.getCurrentPage(state);
    if (currentPage === 'tapBehavior') {
        const { deliverable } = editableCampaign;
        const { tapBehavior } = deliverable;
        return tapBehavior.type === 'PRESENT_EXPERIENCE';
    }
    return currentPage === 'messageAndMedia' || currentPage === 'alertOptions';
};
exports.getSegmentSize = (state) => state.segmentSize;
exports.getIsAudienceSizeUpdating = (state) => state.isAudienceSizeUpdating;
exports.getIsDeviceListUploading = (state) => state.isDeviceListUploading;
exports.getIsSegmentSizeUpdating = (state) => state.isSegmentSizeUpdating;
